import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
import { Link, useNavigate } from 'react-router-dom';
import { GetStartedForm } from './GetStartedForm';
export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isFormOpen, setIsFormOpen] = useState(false);
  const navigate = useNavigate();
  // Handle smooth navigation to new pages
  const handleNavigation = (e, path) => {
    e.preventDefault();
    // If it's a hash link on the same page, use native smooth scroll
    if (path.startsWith('#')) {
      const element = document.querySelector(path);
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth'
        });
      }
      return;
    }
    // For navigation to different pages
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
    // After smooth scroll animation completes, navigate to the new page
    setTimeout(() => {
      navigate(path);
    }, 500); // Adjust timing based on scroll animation duration
  };
  return <header className="bg-white shadow-sm sticky top-0 z-50" data-id="element-263">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-264">
        <div className="flex justify-between items-center py-4" data-id="element-265">
          <div className="flex items-center" data-id="element-266">
            <Link to="/" className="text-2xl font-bold text-black" data-id="element-267">
              agentter.ai
            </Link>
          </div>
          <nav className="hidden md:flex space-x-10" data-id="element-268">
            <a href="/solutions" className="text-gray-700 hover:text-black transition-colors" onClick={e => handleNavigation(e, '/solutions')} data-id="element-269">
              Solutions
            </a>
            <a href="/how-it-works" className="text-gray-700 hover:text-black transition-colors" onClick={e => handleNavigation(e, '/how-it-works')} data-id="element-270">
              How It Works
            </a>
            <a href="/agents" className="text-gray-700 hover:text-black transition-colors" onClick={e => handleNavigation(e, '/agents')} data-id="element-271">
              Agents
            </a>
            <a href="/pricing" className="text-gray-700 hover:text-black transition-colors" onClick={e => handleNavigation(e, '/pricing')} data-id="element-272">
              Pricing
            </a>
          </nav>
          <div className="hidden md:flex items-center space-x-4" data-id="element-273">
            <a href="#" className="text-gray-700 hover:text-black transition-colors" data-id="element-274">
              Sign In
            </a>
            <button onClick={() => setIsFormOpen(true)} className="bg-black text-white px-4 py-2 rounded-lg hover:bg-gray-800 transition-colors" data-id="element-275">
              Get Started
            </button>
          </div>
          <div className="md:hidden" data-id="element-276">
            <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="text-gray-700" data-id="element-277">
              {isMenuOpen ? <X size={24} data-id="element-278" /> : <Menu size={24} data-id="element-279" />}
            </button>
          </div>
        </div>
      </div>
      {/* Mobile menu */}
      {isMenuOpen && <div className="md:hidden bg-white" data-id="element-280">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3" data-id="element-281">
            <a href="/solutions" className="block px-3 py-2 text-gray-700 hover:bg-gray-100 rounded-md" onClick={e => {
          setIsMenuOpen(false);
          handleNavigation(e, '/solutions');
        }} data-id="element-282">
              Solutions
            </a>
            <a href="/how-it-works" className="block px-3 py-2 text-gray-700 hover:bg-gray-100 rounded-md" onClick={e => {
          setIsMenuOpen(false);
          handleNavigation(e, '/how-it-works');
        }} data-id="element-283">
              How It Works
            </a>
            <a href="/agents" className="block px-3 py-2 text-gray-700 hover:bg-gray-100 rounded-md" onClick={e => {
          setIsMenuOpen(false);
          handleNavigation(e, '/agents');
        }} data-id="element-284">
              Agents
            </a>
            <a href="/pricing" className="block px-3 py-2 text-gray-700 hover:bg-gray-100 rounded-md" onClick={e => {
          setIsMenuOpen(false);
          handleNavigation(e, '/pricing');
        }} data-id="element-285">
              Pricing
            </a>
            <a href="#" className="block px-3 py-2 text-gray-700 hover:bg-gray-100 rounded-md" data-id="element-286">
              Sign In
            </a>
            <button onClick={() => {
          setIsMenuOpen(false);
          setIsFormOpen(true);
        }} className="block w-full text-left px-3 py-2 bg-black text-white rounded-md" data-id="element-287">
              Get Started
            </button>
          </div>
        </div>}
      {/* Get Started Form */}
      <GetStartedForm isOpen={isFormOpen} onClose={() => setIsFormOpen(false)} data-id="element-288" />
    </header>;
}